export const FLAG_NAMES = {
  WPLT_FLAGS: {
    ACC_PROJECT_PROFILE_ADDITIONAL_FIELDS:
      'acc-project-profile-additional-fields',
    CREATE_PROJECT_REDIRECT_PA_CONSOLE: 'create-project-redirect-pa-console',
    INVITE_PROJECT_MEMBER_ALLOW_REINVITING:
      'invite-project-member-allow-reinviting',
    INVITE_PROJECT_MEMBER_SHOW_PRODUCTS: 'invite-project-member-show-products',
  },
  ADMIN_FLAGS: {
    ACC_REPLACE_GET_CONSTRUCTION_APIS: 'acc-replace-get-construction-apis',
    ACC_REPLACE_WRITE_CONSTRUCTION_APIS: 'acc-replace-write-construction-apis',
    ACC_ENABLE_ADD_COMPANY_DEBOUNCE: 'acc-enable-add-company-debounce',
    ENABLE_OFFERINGS_CONTAINABILITY: 'enable-offerings-containability',
    ENABLE_PROJECT_ACCESS_LEVELS: 'enable-create-project-access',
    PRODUCTS_SECTION_REDESIGN: 'acc-products-section-redesign',
    SET_DEFAULT_COMPANY_AND_ROLES:
      'acc-project-user-set-default-company-and-roles',
    SHOW_CATEGORIZED_SETTINGS: 'acc-project-admin-settings-categorized-details',
    SHOW_LOCATIONS: 'acc-project-admin-locations-tab',
    SHOW_NOTIFICATIONS: 'acc-project-admin-notifications-tab',
  },
};
